// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container--OQ1cW {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

.editor--TwNAk {
  flex-grow: 1;
  flex-shrink: 1;
  height: 100px;
}

.buttons--xF_4U {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  background-color: #fff;
  font-size: 80%;
}

.buttons--xF_4U > button {
  width: fit-content;
  margin: 0;
  background-color: transparent;
  border: hidden;
  font: inherit;
  padding: 6px 14px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.buttons--xF_4U > button:not(:disabled):hover {
  background-color: #eee;
}

.buttons--xF_4U > button:not(:disabled):hover:active {
  background-color: #ddd;
}

.buttons--xF_4U > button:disabled {
  opacity: 0.5;
}

.buttons--xF_4U > .warning--NLCiy {
  margin-left: 10px;
  color: #700;
  align-self: center;
}

.output--Tc290 {
  flex-grow: 1;
  flex-shrink: 1;
  margin: 0;
}

.error--N2BzT {
  color: red;
}

.no_output--Ydgal {
  color: #999;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./js/interactive-editor/interactive-editor.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n\n.editor {\n  flex-grow: 1;\n  flex-shrink: 1;\n  height: 100px;\n}\n\n.buttons {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: stretch;\n  background-color: #fff;\n  font-size: 80%;\n}\n\n.buttons > button {\n  width: fit-content;\n  margin: 0;\n  background-color: transparent;\n  border: hidden;\n  font: inherit;\n  padding: 6px 14px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n\n.buttons > button:not(:disabled):hover {\n  background-color: #eee;\n}\n\n.buttons > button:not(:disabled):hover:active {\n  background-color: #ddd;\n}\n\n.buttons > button:disabled {\n  opacity: 0.5;\n}\n\n.buttons > .warning {\n  margin-left: 10px;\n  color: #700;\n  align-self: center;\n}\n\n.output {\n  flex-grow: 1;\n  flex-shrink: 1;\n  margin: 0;\n}\n\n.error {\n  color: red;\n}\n\n.no_output {\n  color: #999;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container--OQ1cW`,
	"editor": `editor--TwNAk`,
	"buttons": `buttons--xF_4U`,
	"warning": `warning--NLCiy`,
	"output": `output--Tc290`,
	"error": `error--N2BzT`,
	"no_output": `no_output--Ydgal`
};
export default ___CSS_LOADER_EXPORT___;
